import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stListRooms } from '../../../services/socialTradingService';
import { smartMoneyFilterParam } from './helpers';

const RESOURCE = Resources.socialTradingRooms;
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const roomsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const roomId = String(filter.roomId || '').trim();
    const roomName = String(filter.roomName || '').trim();
    const type = String(filter.type || '').trim() || undefined;
    const visibility = String(filter.visibility || '').trim() || undefined;
    if (roomId && !UUID_RE.test(roomId)) {
      return Promise.reject(new Error('Invalid roomId UUID'));
    }
    const res = await stListRooms({
      roomId: roomId || undefined,
      roomName: roomName || undefined,
      type,
      visibility,
      includeDeleted: !!filter.includeDeleted,
      smartMoney: smartMoneyFilterParam(filter.smartMoney),
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
